import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsPlanYourVisitShowMoreClickedParams = {
  trail_id?: string;
};

/**
 * User clicks ‘show more’ in the ‘plan your visit’ section of the web trail page.
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id - Trail page user was on when they clicked the 'show more' button.
 */
const logTrailDetailsPlanYourVisitShowMoreClicked = ({ trail_id }: logTrailDetailsPlanYourVisitShowMoreClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('trail details plan your visit show more clicked', { 'trail id': trail_id }, callback);
};

export default logTrailDetailsPlanYourVisitShowMoreClicked;
